import { Select, Spin } from "antd";
import { useRemoteHandbookOptions } from "features/handbook/hooks/useRemoteHandbookOptions";

type Props = {
  slug: string;
  value?: number | null;
  onChange?: (val?: number) => void;
  placeholder?: string;
  language?: "ru" | "ky";
  initialOption?: { value: number; label: string } | null;
  disabled?: boolean;
};

export default function RemoteHandbookSelect({
  slug,
  value,
  onChange,
  placeholder = "Выберите...",
  language = "ru",
  initialOption,
  disabled,
}: Props) {
  const {
    options,
    isFetching,
    loadingMore,
    setSearch,
    fetchMore,
    canLoadMore,
  } = useRemoteHandbookOptions({ slug, language, initialOption });

  return (
    <Select
      value={value ?? undefined}
      onChange={(val) => onChange?.(val)}
      showSearch
      allowClear
      placeholder={placeholder}
      options={options}
      optionFilterProp="label"
      filterOption={false}
      onSearch={setSearch}
      listHeight={320}
      virtual
      dropdownStyle={{ maxHeight: 320, overflow: "auto" }}
      getPopupContainer={(node) => node?.parentElement || document.body}
      onPopupScroll={(e) => {
        const el = e.currentTarget as HTMLDivElement;
        const nearBottom =
          el.scrollTop + el.clientHeight >= el.scrollHeight - 24;
        if (nearBottom && canLoadMore && !loadingMore) fetchMore();
      }}
      notFoundContent={loadingMore || isFetching ? <Spin size="small" /> : null}
      loading={loadingMore || isFetching}
      disabled={disabled}
    />
  );
}
